import { render, staticRenderFns } from "./AgentRegisteCerticate.vue?vue&type=template&id=534874cb&scoped=true"
import script from "./AgentRegisteCerticate.vue?vue&type=script&lang=js"
export * from "./AgentRegisteCerticate.vue?vue&type=script&lang=js"
import style0 from "./AgentRegisteCerticate.vue?vue&type=style&index=0&id=534874cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534874cb",
  null
  
)

export default component.exports